angular.module("listingOverviewModule").component("listingOverviewPhotos", {
	templateUrl: "listingOverviewPhotos/listingOverviewPhotos.html",
	bindings: {
		listingPopupUrl: '@',
        photoList: '<',
        floorplanImage: '<'
	},
	controller: ["$scope", "$document", "$timeout", "$sce", "$element", function($scope, $document, $timeout, $sce, $element) {
		var self = this;

		this.$onInit = function () {
			self.isOverlayVisible = false;
			self.currentIndex = 0;
			self.sliderOffset = 0;
			self.dragStartX = 0;
			self.dragEndX = 0;
			self.isDragging = false;
			// Decode HTML entities in photoList descriptions
			$timeout(() => {
				if (self.photoList) {
				
					self.photoList = self.photoList.map(photo => {
						if (photo.descr) {
							photo.descr = self.replaceQuoteEntities(photo.descr);
						}
						if (photo.descr_short) {
							photo.descr_short = self.replaceQuoteEntities(photo.descr_short);
						}
						return photo;
					});
				}
			});
		};

		this.replaceQuoteEntities = function (str) {
			return str.replace('--q--', '"'); // Replace all occurrences of &quot; with "
		};

		this.toggleImageTag = function (event, photo) {
			event.stopPropagation();
			event.preventDefault();
			let target = event.target;
			let metaDiv = target.closest('.meta');

			if (metaDiv && !metaDiv.classList.contains('small-only')) {
				metaDiv.classList.toggle('active');
				photo.isActive = !photo.isActive;
				const shortText = metaDiv.querySelector('.short');
				const longText = metaDiv.querySelector('.long');

				if (metaDiv.classList.contains('active')) {
					metaDiv.style.height = `${longText.scrollHeight + 2}px`;
					metaDiv.style.width = `${longText.scrollWidth + 2}px`;
				} else {
					metaDiv.style.height = `${shortText.scrollHeight + 2}px`;
					metaDiv.style.width = `${shortText.scrollWidth + 2}px`;
				}

			}
			return false;
		};
		
		this.openPhotos = function (index) {
			if (self.listingPopupUrl) {
				self.showPhotos('photos');
				return;
			}
			self.isOverlayVisible = true;
			self.currentIndex = index !== undefined ? index : 0;
			self.updateSliderOffset();
			$timeout(() => {
				self.addMouseDragEvents();
				self.addTouchEvents();
				self.photoList.forEach(photo => {
					photo.isActive = true;
				});

        		const sliderWrapper = $element[0].querySelector(".slider-wrapper");
				const metaDivs = sliderWrapper.querySelectorAll('.meta');
				
				metaDivs.forEach(metaDiv => {
					const longText = metaDiv.querySelector('.long');

					metaDiv.style.height = `${longText.scrollHeight + 2}px`;
					metaDiv.style.width = `${longText.scrollWidth + 2}px`;
				});

			}, 0);
		};

		this.closePhotos = function () {
			self.isOverlayVisible = false;
			self.removeMouseDragEvents();
		};

		this.prevSlide = function () {
			self.currentIndex = self.currentIndex > 0 ? self.currentIndex - 1 : self.photoList.length - 1;
			self.updateSliderOffset();
		};

		this.nextSlide = function () {
			self.currentIndex = self.currentIndex < self.photoList.length - 1 ? self.currentIndex + 1 : 0;
			self.updateSliderOffset();
		};

		this.updateSliderOffset = function () {
			self.sliderOffset = -self.currentIndex * 100;
		};

		this.onMouseDown = function (event) {
			if (event.target.closest('.meta')) {
				// Prevent dragging inside .meta
				return;
			}
			event.preventDefault(); // Prevent default actions
			self.isDragging = true;
			self.dragStartX = event.clientX;
		}.bind(self);

		this.onMouseMove = function (event) {
			if (self.isDragging) {
				self.dragEndX = event.clientX;
			}
		}.bind(self);

		this.onMouseUp = function () {
			if (self.isDragging) {
				const dragDistance = self.dragStartX - self.dragEndX;

				if (dragDistance > 50) {
					self.nextSlide();
				} else if (dragDistance < -50) {
					self.prevSlide();
				}

				self.isDragging = false;
				self.dragStartX = 0;
				self.dragEndX = 0;
			}
		}.bind(self);

		this.addMouseDragEvents = function () {
			const sliderWrapper = $element[0].querySelector(".slider-wrapper");

			if (sliderWrapper) {
				sliderWrapper.addEventListener("mousedown", self.onMouseDown);
				window.addEventListener("mousemove", self.onMouseMove);
				window.addEventListener("mouseup", self.onMouseUp);
			}
		};

		this.removeMouseDragEvents = function () {
			const sliderWrapper = $element[0].querySelector(".slider-wrapper");

			if (sliderWrapper) {
				sliderWrapper.removeEventListener("mousedown", self.onMouseDown);
				window.removeEventListener("mousemove", self.onMouseMove);
				window.removeEventListener("mouseup", self.onMouseUp);
			}
		};

		this.addTouchEvents = function () {
			const sliderWrapper = $element[0].querySelector(".slider-wrapper");

			if (sliderWrapper) {
				sliderWrapper.addEventListener("touchstart", function (event) {
					self.dragStartX = event.touches[0].clientX;
				});

				sliderWrapper.addEventListener("touchmove", function (event) {
					self.dragEndX = event.touches[0].clientX;
				});

				sliderWrapper.addEventListener("touchend", function () {
					const dragDistance = self.dragStartX - self.dragEndX;

					if (dragDistance > 50) {
						self.nextSlide();
					} else if (dragDistance < -50) {
						self.prevSlide();
					}

					self.dragStartX = 0;
					self.dragEndX = 0;
				});
			}
		};

		this.$onDestroy = function () {
			self.removeMouseDragEvents();
		};

		this.openPhotosTab = function (e) {
			if (self.listingPopupUrl) {
				self.showPhotos('photos');
				return;
			}
            var photogalleryTabs = document.querySelectorAll('.lst_links .photogallery');
            photogalleryTabs.forEach(function(photogalleryTab) {
                photogalleryTab.click();
            });
        }
        this.openFloorplanTab = function (e) {
			if (self.listingPopupUrl) {
				self.showPhotos('floorplan');
				return;
			}
            var photogalleryTabs = document.querySelectorAll('.lst_links .floorplan');
            photogalleryTabs.forEach(function(photogalleryTab) {
                photogalleryTab.click();
            });
        }

		
		this.showPhotos = function(tab = 'photos') {
			if (self.listingPopupUrl) {
				$element.blimp = new BlimpExtV2(null, {
					cache: false,
					draggable: true,
					show_veil: true,
					display: tab,
					fullscreen: true,
					rpc_url: self.listingPopupUrl,
					onFetch: function() {
						_gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
					},
					onPostRpc: function() {
						this.add_extra(true);

						Core.compile_html(this._element);
					}
				});
				$element.blimp.handle_link_click();
			}
		};


	}]
});